import React, { useState } from 'react';
import { Mail, Search, MailCheck } from 'lucide-react';
import { redeemByEmail, validateEmail } from '../../services/paymentService';

export const RedeemSection = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [error, setError] = useState('');

  const handleSearch = async () => {
    const emailError = validateEmail(email);
    if (emailError) {
      setError(emailError);
      return;
    }

    setError('');
    setIsLoading(true);
    setSearched(false);

    try {
      await redeemByEmail(email.trim().toLowerCase());
      setSearched(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !isLoading) handleSearch();
  };

  return (
    <section className="py-8" aria-labelledby="resgatar-heading">
      <div className="bg-white rounded-3xl shadow-xl p-6 sm:p-8">
        <div className="max-w-xl mx-auto">
          <div className="text-center mb-6">
            <div className="text-4xl mb-3" role="img" aria-label="Resgatar ebook">📥</div>
            <h2 id="resgatar-heading" className="text-2xl font-bold text-gray-900 mb-1">
              Resgatar meu Ebook
            </h2>
            <p className="text-sm text-gray-500">
              Já comprou e não encontrou o e-mail? Informe o e-mail usado na compra.
            </p>
          </div>

          {/* Campo de e-mail */}
          <div className="mb-4">
            <label htmlFor="redeem-email" className="block text-sm font-medium text-gray-700 mb-2">
              <Mail className="inline mr-1" size={14} aria-hidden="true" />
              E-mail utilizado na compra
            </label>
            <div className="flex gap-2">
              <input
                id="redeem-email"
                type="email"
                value={email}
                onChange={(e) => { setEmail(e.target.value); setError(''); setSearched(false); }}
                onKeyPress={handleKeyPress}
                placeholder="seuemail@gmail.com"
                disabled={isLoading}
                className={`flex-1 px-4 py-3 border-2 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 transition-colors ${
                  error ? 'border-red-400' : 'border-gray-300 focus:border-transparent'
                }`}
                aria-describedby={error ? 'redeem-error' : undefined}
              />
              <button
                onClick={handleSearch}
                disabled={isLoading || !email}
                className="px-5 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors flex items-center gap-2 text-sm"
                aria-label="Buscar ebooks"
              >
                {isLoading ? (
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" aria-hidden="true" />
                ) : (
                  <Search size={16} aria-hidden="true" />
                )}
                {isLoading ? 'Buscando...' : 'Buscar'}
              </button>
            </div>

            {error && (
              <p id="redeem-error" className="mt-2 text-xs text-red-600 flex items-center gap-1" role="alert">
                <span aria-hidden="true">⚠️</span> {error}
              </p>
            )}
          </div>

          {/* Resultado — sempre a mesma mensagem, exista ou não pedido, para não
              revelar se aquele e-mail específico comprou (e de qual lado). */}
          {searched && (
            <div className="mt-4 flex items-start gap-2 p-3 bg-blue-50 border border-blue-200 rounded-xl">
              <MailCheck className="text-blue-600 flex-shrink-0 mt-0.5" size={16} aria-hidden="true" />
              <p className="text-xs text-blue-800">
                Se houver compras confirmadas para esse e-mail, os links de download foram reenviados. Confira sua caixa de entrada (e o spam).
              </p>
            </div>
          )}

          {/* Nota de privacidade */}
          <p className="mt-5 text-center text-xs text-gray-400">
            🔒 Seus dados são usados exclusivamente para localizar seu pedido.
          </p>
        </div>
      </div>
    </section>
  );
};
